export default __webpack_public_path__ + "static/media/16.93aac98a.jpg";